import type { Theme, WithStyles } from "@envestnet/envreact-component-library";
import { createStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    container: {},
    descriptionClass: {
      ...theme.fonts.p2,
      textAlign: "left",
      marginTop: 32,
    },
    informationClass: {
      ...theme.fonts.caption,
      marginTop: 8,
      color: theme.colors.textSubtle,
      textAlign: "left",
    },
    textfieldClass: {
      "& > *": {
        textAlign: "left",
      },
      paddingTop: 32,
    },
    verifyButtonClass: {
      width: "100%",
      marginTop: 32,
    },
    linkButtonClass: {
      marginTop: 32,
      paddingLeft: 0,
      float: "left",
    },
    disabledTextFieldClass: {
      ...theme.fonts.p2,
      textAlignLast: "center",
      color: theme.colors.textDefault,
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
